module.exports = __webpack_public_path__ + "static/media/Neon_Main.2c83099e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Neon_Main.webp
// module id = ./src/assets/Neon_Main.webp
// module chunks = 0